'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import { useHits } from 'react-instantsearch';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import avo from 'analytics/avo';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import useSearchUrlQueryParams from '../../../advanced-search/hooks/useSearchUrlQueryParams';
const ResultsHeader = t0 => {
  const $ = _c(6);
  const {
    variant: t1,
    children
  } = t0;
  const variant = t1 === undefined ? "desktop" : t1;
  const t2 = variant !== "mobile";
  const t3 = variant === "mobile";
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = classNames("mx-0 my-2.5 text-base font-bold", {
      "text-gray": t2,
      "text-brand block mt-[15px] mb-[7px]": t3
    });
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== children || $[4] !== t4) {
    t5 = <div className={t4}>{children}</div>;
    $[3] = children;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
ResultsHeader.propTypes = {
  variant: PropTypes.string,
  children: PropTypes.node
};

/**
 * CategoryHits component for Next version (v7)
 * Uses useHits hook instead of connectHits
 */
const CategoryHitsNext = t0 => {
  const $ = _c(21);
  const {
    toggleSearchOpen,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "desktop" : t1;
  const {
    items: hits
  } = useHits();
  const {
    queryUrlParam: query
  } = useSearchUrlQueryParams();
  const currentPage = useUserCurrentPageType();
  let t2;
  if ($[0] !== hits) {
    t2 = hits.reduce(_temp, []);
    $[0] = hits;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const items = t2;
  if (!items.length) {
    return null;
  }
  const t3 = variant === "mobile";
  let t4;
  if ($[2] !== t3) {
    t4 = classNames("[border-right:1px_solid_#f1f1f1] pt-5 pr-8 pb-10 min-w-[20%] flex-[0_1_20%] pl-[30px] h-full min-h-[264px]", {
      "!p-0 min-h-[auto] mb-2 w-full border-0 order-[-1]": t3
    });
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== variant) {
    t5 = <ResultsHeader variant={variant}>Categories</ResultsHeader>;
    $[4] = variant;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== currentPage || $[7] !== items || $[8] !== query || $[9] !== toggleSearchOpen || $[10] !== variant) {
    let t7;
    if ($[12] !== currentPage || $[13] !== query || $[14] !== toggleSearchOpen || $[15] !== variant) {
      t7 = item => <div key={item.objectID}><Link className={classNames("text-sm font-bold mt-1 mb-1 ml-0 no-underline !leading-[1.5rem] active:bg-gray-light8 focus:bg-gray-light8 hover:bg-gray-light8", {
          "block mr-2.5 text-[#585858]": variant === "desktop",
          "text-sm px-2 py-1 rounded-[3px] text-gray font-bold mr-2.5 bg-gray-light9 inline-block": variant === "mobile"
        })} onClick={async () => {
          await toggleSearchOpen();
          avo.productsSearched({
            query,
            location: currentPage,
            searchTarget: avo.SearchTarget.OTHER_RESULTS_LINK
          });
        }} to={item.categoryUrl}>{item.categoryLabel}</Link></div>;
      $[12] = currentPage;
      $[13] = query;
      $[14] = toggleSearchOpen;
      $[15] = variant;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    t6 = items.map(t7);
    $[6] = currentPage;
    $[7] = items;
    $[8] = query;
    $[9] = toggleSearchOpen;
    $[10] = variant;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[17] !== t4 || $[18] !== t5 || $[19] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
CategoryHitsNext.propTypes = {
  toggleSearchOpen: PropTypes.func,
  variant: PropTypes.string
};
export default CategoryHitsNext;
function _temp(acc, hit) {
  const highlightedCategory = hit?._highlightResult?.category_name?.value || "";
  const categoryLabelRaw = hit?.category_name || highlightedCategory.replace(/<[^>]+>/g, "");
  const categoryLabel = categoryLabelRaw?.trim();
  if (!categoryLabel) {
    return acc;
  }
  const categoryUrl = hit.category_sef_url || hit.url || `/categories/${categoryLabel.toLowerCase().replace(/\s+/g, "-")}`;
  acc.push({
    objectID: hit.objectID,
    categoryLabel,
    categoryUrl
  });
  return acc;
}